import React from 'react';
import RecommendEventDetailNavbar from '../RecommendEventDetailNavbar';
import RecommendEventDetailInfo from '../RecommendEventDetailInfo';
import RecommendEventDetailItemList from '../RecommendEventDetailItemList';
import './RecommendEventDetailWrap.scss';

const RecommendEventDetailWrap = (props) => {
  const { recommendEventDetail } = props;
  const { recommendEventInfo, recommendEventItemList } = recommendEventDetail;

  return (
    <div className="recommend-event-detail-wrap">
      {/* 하단 네브바 */}
      <RecommendEventDetailNavbar recommendEventId={recommendEventInfo.recommendEventId} />

      {/* 추천 상품 후기 정보 */}
      <RecommendEventDetailInfo recommendEventInfo={recommendEventInfo} />

      {/* 추천 상품 후기 아이템 리스트*/}
      <RecommendEventDetailItemList recommendEventItemList={recommendEventItemList} />
    </div>
  );
};

export default RecommendEventDetailWrap;
